import { Chip } from "@mui/material";
import React, {useMemo,memo}from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const CoKPI = memo(({avgCO, maxCO, minCO}) => {
  const percentage = useMemo(()=>{
  
    if (avgCO >35  && avgCO <=500) return 0.2;
    if (avgCO > 9 && avgCO <= 35) return 0.5;
    if (avgCO >= 0 && avgCO <= 9) return 0.8;
    
    return 0.2; 
  
  },[avgCO])
  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.1,0.1,0.1]}
        colors={["red","yellow","#82f61d"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgCO} ppm</span>
      <p className="card-value">CO</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max"  sx={chipStyle} />
          <p className="m-1 p-0">{maxCO}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min" sx={chipStyle} />
          <p className="m-1 p-0">{minCO}</p>
        </div>
      </div>
 
    </>
  );
});

export default CoKPI;
